import { Stack, useMediaQuery } from "@mui/material";
import TrackingPreferences from "./TrackingPreference";
import { GET_USER_SETUP_PROGRESS } from "../../graphql/queries";
import { useQuery } from "@apollo/client";
import SetupProgressBar from "../../components/SetupProgressBar";
import { SetupSteps } from "../../types";
import MedicationOnboarding from "../../components/MedicationOnboarding";
import { useEffect } from "react";
import { colors, ROUTES, screenSize } from "../../constants";
import { useNavigate } from "react-router-dom";
import Skeleton from "./Skeleton";

const InitSetup = () => {
  const isTablet = useMediaQuery(`(max-width:${screenSize.tablet})`);

  const { data, loading } = useQuery(GET_USER_SETUP_PROGRESS);
  const navigate = useNavigate();

  const progress = data?.getUserSetupProgress?.progress;

  const isTrackingPreferenceStepCompleted =
    progress?.[SetupSteps.TRACKING_PREFERENCES];

  const isMedicationStepCompleted = progress?.[SetupSteps.MEDICATIONS];

  const hasUserCompletedOnboarding = !!data?.getUserSetupProgress?.completedAt;

  useEffect(() => {
    if (hasUserCompletedOnboarding) {
      navigate(ROUTES.DASHBOARD);
    }
  }, [hasUserCompletedOnboarding, navigate]);

  if (loading) {
    return <Skeleton sx={{ bgcolor: colors.lightGrey4 }} />;
  }

  return (
    <Stack gap={3} p={2} pb={isTablet ? 6 : 0}>
      <SetupProgressBar progress={progress} />
      {!isTrackingPreferenceStepCompleted && <TrackingPreferences />}
      {isTrackingPreferenceStepCompleted && !isMedicationStepCompleted && (
        <MedicationOnboarding />
      )}
    </Stack>
  );
};

export default InitSetup;
